/** @format */

import validPolicyCountries from '@tenant/app/utils/constants/validPolicyCountries';

export function validateCountryCode(countryCode) {
    return validPolicyCountries.OPTIONS.includes(countryCode.toLowerCase());
}
